import React from 'react';
import { Fingerprint, Paperclip } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-noir-bg border-b border-noir-border relative" data-id="element-162">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-163">
        <div className="text-center mb-12" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-mono text-noir-text uppercase tracking-tight" data-id="element-165">
            El Escenario del <span className="text-noir-alert" data-id="element-166">Crimen</span>
          </h2>
        </div>

        {/* Manila Folder Style Block */}
        <div className="bg-noir-paper rounded-sm p-8 md:p-12 shadow-[0_10px_30px_rgba(0,0,0,0.8)] relative border border-[#D7CCC8] transform rotate-1" data-id="element-167">
          {/* Confidential Stamp */}
          <div className="absolute top-6 right-6 border-4 border-noir-alert text-noir-alert font-mono font-bold text-xl md:text-2xl px-3 py-1 transform rotate-12 opacity-70 uppercase tracking-widest pointer-events-none" data-id="element-168">
            Confidencial
          </div>

          <div className="flex items-start mb-8 border-b-2 border-black/10 pb-6" data-id="element-169">
            <Paperclip className="w-8 h-8 text-black/40 mr-4 flex-shrink-0 transform -rotate-45" data-id="element-170" />
            <h3 className="text-2xl font-mono font-bold text-black uppercase tracking-tight" data-id="element-171">
              Reporte de Incidente #402
            </h3>
          </div>

          <div className="space-y-6 text-black/80 font-sans text-lg leading-relaxed" data-id="element-172">
            <p className="font-bold text-xl text-black" data-id="element-173">
              ¿Reconoces este patrón?
            </p>

            <div className="flex items-start space-x-4 bg-black/5 p-4 rounded-sm border-l-4 border-noir-alert" data-id="element-174">
              <Fingerprint className="w-6 h-6 text-noir-alert flex-shrink-0 mt-1" data-id="element-175" />
              <p data-id="element-176">
                ¿Cenan juntos pero en silencio? El problema no es que no tengan
                nada que decir; es que los mecanismos para hablar se han roto.
              </p>
            </div>

            <div className="flex items-start space-x-4 bg-black/5 p-4 rounded-sm border-l-4 border-noir-alert" data-id="element-177">
              <Fingerprint className="w-6 h-6 text-noir-alert flex-shrink-0 mt-1" data-id="element-178" />
              <p data-id="element-179">
                La rutina y el celular son el tercer integrante de su relación.
              </p>
            </div>

            <p className="pt-4 font-mono text-sm text-black/60 uppercase tracking-widest border-t border-black/10" data-id="element-180">
              Fin del reporte. Se requiere intervención inmediata.
            </p>
          </div>
        </div>
      </div>
    </section>;
}